export type Law = {
  id: string
  topic: string
  reference: string
  description: string
}

export const laws: Law[] = [
  {
    id: 'anticorrupcao',
    topic: 'Anticorrupção',
    reference: 'Lei 12.846/12',
    description:
      'que dispõe sobre a responsabilização objetiva administrativa e civil de pessoas jurídicas pela prática de atos contra a administração pública, nacional ou estrangeira.'
  },
  {
    id: 'lavagem-de-dinheiro',
    topic: 'Crimes de Lavagem de Dinheiro',
    reference: 'Lei 9.613/98',
    description:
      'que alerta e orienta as instituições financeiras a práticas que buscam omitir a origem de ativos financeiros ou bens ilícitos.'
  },
  {
    id: 'lgpd',
    topic: 'LGPD',
    reference: 'Lei 13.709/18',
    description:
      'que estabelece diretrizes importantes e obrigatórias para a coleta, processamento e armazenamento de dados pessoais.'
  },
  {
    id: 'resolucao-cmn',
    topic: 'Resolução CMN',
    reference: 'Resolução N° 4.935',
    description:
      'que dispõe sobre a contratação de correspondentes no País pelas instituições financeiras e pelas demais instituições autorizadas a funcionar pelo Banco Central do Brasil.'
  }
]
